import { RootState } from 'src/store';
import { FormAuthState } from './slice';

const defaultFormAuthState: FormAuthState = {
  loading: false,
  success: false,
  errorCode: null,
  error: null,
  data: null,
  verificationStatus: 'idle',
};

export const getFormAuthState = (state: RootState): FormAuthState =>
  state.formAuth || defaultFormAuthState;

export const getFormAuthLoading = (state: RootState) =>
  getFormAuthState(state).loading;

export const getFormAuthErrorCode = (state: RootState) =>
  getFormAuthState(state).errorCode;

export const getFormAuthError = (state: RootState) =>
  getFormAuthState(state).error;

export const getFormAuthData = (state: RootState) =>
  getFormAuthState(state).data;

export const getVerificationStatus = (state: RootState) =>
  getFormAuthState(state).verificationStatus;

export const getFormAuthSuccess = (state: RootState) =>
  getFormAuthState(state).success;

export const getFormAuthResendTimer = (state: RootState) => {
  const raw = getFormAuthData(state)?.resend_otp_timer_secs;

  if (typeof raw !== 'number') return 30000;

  return raw >= 1000 ? raw : raw * 1000;
};
